import React from 'react';
import styled from 'styled-components';
const OverlayLoaderContainer = styled.div `
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  background-color: #000;
  opacity: ${props => props.visible ? '0.5' : '0'};
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  transition: opacity 1s;
  z-index: 50;
`;
export const OverlayLoader = (props) => {
    return React.createElement(OverlayLoaderContainer, { visible: props.active });
};
